import { gql } from '@apollo/client/core';

export const COMPLETE_CARE_TYPE_TASK = gql`
  mutation ($careType: String!) {
    completeCareTypeTask(careType: $careType) {
      careTypeTask {
        complete
        careType
      }
    }
  }
`;

export default {
  COMPLETE_CARE_TYPE_TASK,
};
